<template>
  <div class="expansion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row align="center" no-gutters>
            <v-col cols="12" md="8">
              <p class="text-body-1 font-weight-medium">
                {{ qualification.name }}
              </p>
            </v-col>
            <v-col class="d-flex justify-md-end mt-5 mt-md-0" cols="12" md="3">
              <mark-as-evaluated
                is-qualification
                :uuid="qualification.uuid"
                @get-courses="$emit('get-courses')"
              />
            </v-col>
            <v-col
              class="d-md-flex d-none justify-end align-center"
              cols="12"
              lg="1"
              md="1"
            >
              <p
                class="primary--text text-body-1"
                v-text="open ? 'Collapse' : 'Expand'"
              />
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-expansion-panels>
          <div
            v-for="(course, i) in qualification.courses"
            :key="i"
            class="expansion-panel-wrapper"
          >
            <course-panel
              :course="course"
              @get-courses="$emit('get-courses')"
            />
          </div>
        </v-expansion-panels>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import CoursePanel from './CoursePanel'
import MarkAsEvaluated from './MarkAsEvaluated'

export default {
  name: 'QualificationPanel',

  components: {
    CoursePanel,
    MarkAsEvaluated,
  },

  props: {
    qualification: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.expansion-panel {
  .v-expansion-panel {
    background-color: var(--v-secondary-base);
    margin: 0.5rem 0;

    /**
     * If this class is not provided due to propagation stopping,
     * there is a weird opacity ripple effect
     */
    .v-expansion-panel-header::before {
      opacity: 0 !important;
    }

    ::v-deep .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
      color: var(--v-primary-base);
    }

    &::before {
      box-shadow: none;
    }
    // Every expansion panel other than the first one has a border colour
    &:not(:first-child)::after {
      border-color: #fff;
    }

    .expansion-panel-wrapper {
      width: 100%;
    }
  }
}
</style>
